import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface GAIAHeaderStripStyles {
    wrapper?: InjectableCss;
}

export const headerStripStyles: GAIAHeaderStripStyles = {
    wrapper: {
        css: css`
            background-color: ${getColor("primary")};
            padding-left: 1.5rem;
            display: flex;
            width: "100%";
            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle"] {
                            align-items: center;
                            &:last-child {
                                > div[class^="Wrapper"] {
                                    display: flex;
                                    justify-content: flex-end;
                                }
                            }
                        }
                    }
                    margin: 0 auto;
                }
            }
            .header-strip-shop-now {
                text-decoration: underline;
                font-size: 14px;
                &:hover {
                    text-decoration: none;
                }
                span {
                    color: #fff;
                    &:hover {
                        color: #fff;
                    }
                }
            }
            div[class^="Wrapper"] div[class^="sc"] {
                padding: 0;
                margin: 0;

                a {
                    cursor: pointer;
                    &:hover {
                        background-color: #1d4a36;
                    }
                    p {
                        color: #fff;
                        padding: 0.5rem 1.5rem;
                        margin: 0px;
                        text-transform: capitalize;
                        font-size: 14px;
                    }
                }
            }
        `,
    },
};

const styles = headerStripStyles;

const GAIAHeaderStrip: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper} className="onScrollHeaderStrip">
            <Zone contentId={id} zoneName="HeaderStrip" />
        </StyledWrapper>
    );
};

const headerStrip: WidgetModule = {
    component: GAIAHeaderStrip,
    definition: {
        group: "Common",
        displayName: "GAIA Header Strip",
        icon: "link-simple",
    },
};

export default headerStrip;
